.NoShadow
    box-shadow: none !important

.RentwareButton
    position: relative
    min-height: 40px
    min-width: 100px
    max-width: 100%
    font-size: 14px
    font-weight: 700
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    flex-shrink: 0
    border-radius: $globalButtonRounding
    box-sizing: border-box
    overflow: hidden
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .ButtonInnerClickableArea
        width: 100%
        display: flex
        justify-content: center
        align-items: center
        align-self: stretch
        box-sizing: border-box
        border-radius: $globalButtonRounding
        border: none !important
        cursor: pointer
        background-position: center
        transition: background 0.8s
        text-align: center
        padding: 5px 20px
    .ActiveButton
        &:active
            background-size: 100%
            transition: background 0s
        &:focus
            box-shadow: none
            outline: none
    .ButtonInnerClickableAreaSmall
        padding: 7px 10px


.DefaultButton
    background-color: rgb($globalButtonBackgroundPrimary)
    position: relative
    overflow: hidden
    color: rgb($globalButtonFontPrimary)
    stroke: rgb($globalButtonFontPrimary)
    & .GradientButton::after
        display: block
        content: ""
        position: absolute
        width: 100%
        height: 100%
        top: 0
        left: 0
        pointer-events: none
        background: linear-gradient(266.43deg, rgb($globalButtonBackgroundPrimary) -32%, #00000000 15%)
.DefaultButtonActive
    &:hover
        background: rgb($globalButtonBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalButtonBackgroundTertiary) 1%) center/15000%
    &:active
        background-color: rgb($globalButtonBackgroundPrimary)

.InverseButton
    background: rgb($globalSettingsBackgroundPrimary)
    color: rgb($globalSettingsFontPrimary)
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    stroke: rgb($globalSettingsFontPrimary)
    box-shadow: none !important
    font-weight: 400
.InverseButtonActive
    &:hover
        background: rgb($globalSettingsBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalSettingsBackgroundTertiary) 1%) center/15000%
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &:active
        background-color: rgb($globalSettingsBackgroundPrimary)

.NotAvailableButton
    background: rgb($globalSettingsStrokePrimary)
    color: rgb($globalSettingsBackgroundPrimary)
    stroke: rgb($globalSettingsBackgroundPrimary)
.NotAvailableButtonActive
    &:hover
        background: rgb($globalSettingsStrokeSecondary) radial-gradient(circle, transparent 1%, rgb($globalSettingsStrokeTertiary) 1%) center/15000%
    &:active
        background-color: rgb($globalSettingsStrokePrimary)

.S
    min-height: 20px
    font-size: 12px
.M
    min-height: 32px
.L
    min-height: 40px
.XL
    min-height: 48px
    font-size: 16px

.FullWidth
    width: 100%

.ControlsContainer
    height: 100%
    display: flex
    box-sizing: border-box

.ButtonDisabled
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: rgb($globalSettingsBackgroundPrimary)
    opacity: 0.5
.ButtonWaiting
    cursor: wait
